import React from 'react';
//import loading from '../../loading.svg';
import './style.css'
const images = require("../../images.json");
const loading = images.loading

export default class LoadingComponent extends React.Component {
    render() {
        return (
            <div className="Loading">
                <img alt="Loading..." src={loading} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/loading/index.js